<template>
  <div>
    <form class="m-b-0 p-b-0">
      <ul class="category-list m-b-0 p-b-0">
        <li class="list-header m-b-0 p-b-0">
          <input style="font-weight: normal;" type="text" class="form-control" placeholder="Search..." aria-label="Search..." v-model="searchInput">
        </li>
      </ul>
    </form>
    <ul id="accordion" role="tablist" class="category-list">
      <li class="m-b-20">
        <a class="deco-none collapsed" style="font-weight: 400;text-decoration: underline;color: #999;" data-toggle="collapse" href="#collapseKeyWords" aria-expanded="false" aria-controls="collapseKeyWords">
          Advanced search
        </a>
        <div id="collapseKeyWords" class="collapse" role="tabpanel" aria-labelledby="headingZero">
          <div class="card-body">
            <div class="form-check">
              <div class="checkbox checkbox-css checkbox-success">
                <input type="checkbox" id="cssCheckbox_osirix" v-model="viewer" value="osirix">
                <label for="cssCheckbox_osirix">Osirix</label>
              </div>
            </div>
            <div class="form-check">
              <div class="checkbox checkbox-css checkbox-success">
                <input type="checkbox" id="cssCheckbox_horos" v-model="viewer" value="horos"> 
                <label for="cssCheckbox_horos">Horos</label>
              </div>
            </div>
            <div class="form-check">
              <div class="checkbox checkbox-css checkbox-success">              
                <input type="checkbox" id="cssCheckbox_free" v-model="free" value="true"> 
                <label for="cssCheckbox_free">Free</label>
              </div>
            </div>
            <div class="form-check">
              <div class="checkbox checkbox-css checkbox-success">                
                <input type="checkbox" id="cssCheckbox_certif" v-model="certified" value="true">
                <label for="cssCheckbox_certif">Certified</label>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li>
        <a class="deco-none collapsed" data-toggle="collapse" href="#collapseClinicalArea" aria-expanded="false" aria-controls="collapseClinicalArea">
          <i style="font-size: 130%;" class="fa fa-user-md text-success m-r-10"></i>
          Clinical area
          <i style="margin-top: 4px;" class="fa fa-chevron-right text-muted pull-right"></i>
          <i style="margin-top: 4px;" class="fa fa-chevron-down text-muted pull-right"></i>
        </a>
        <div id="collapseClinicalArea" class="collapse" role="tabpanel" aria-labelledby="headingOne">
          <div class="card-body">
            <div class="form-check" v-bind:key="clinicalArea" v-for="clinicalArea in clinicalAreas">              
              <div class="checkbox checkbox-css checkbox-success">
                <input type="checkbox" :id="`cssCheckbox_${clinicalArea}`" v-model="categories" :value="clinicalArea">
                <label :for="`cssCheckbox_${clinicalArea}`">{{ clinicalArea }}</label>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li>
        <a class="deco-none collapsed" data-toggle="collapse" href="#collapseModality" aria-expanded="false" aria-controls="collapseModality">
          <i style="font-size: 130%;" class="fa fa-universal-access text-success m-r-10"></i>
          Modality
          <i style="margin-top: 4px;" class="fa fa-chevron-right text-muted pull-right"></i>
          <i style="margin-top: 4px;" class="fa fa-chevron-down text-muted pull-right"></i>
        </a>
        <div id="collapseModality" class="collapse" role="tabpanel" aria-labelledby="headingTwo">
          <div class="card-body">
            <div class="form-check" v-bind:key="mod" v-for="mod in modalities">
              <div class="checkbox checkbox-css checkbox-success">
                <input type="checkbox" :id="`cssCheckbox_${mod}`" v-model="categories" :value="mod">
                <label :for="`cssCheckbox_${mod}`">{{ mod }}</label>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li>
        <a class="deco-none collapsed" data-toggle="collapse" href="#collapseApplication" aria-expanded="false" aria-controls="collapseApplication">
          <i style="font-size: 130%;" class="fa fa-cog text-success m-r-10"></i>
          Application
          <i style="margin-top: 4px;" class="fa fa-chevron-right text-muted pull-right"></i>
          <i style="margin-top: 4px;" class="fa fa-chevron-down text-muted pull-right"></i>
        </a>
        <div id="collapseApplication" class="collapse" role="tabpanel" aria-labelledby="headingThree">
          <div class="card-body">
            <div class="form-check" v-bind:key="app" v-for="app in applications">
              <div class="checkbox checkbox-css checkbox-success">
                <input type="checkbox" :id="`cssCheckbox_${app}`" v-model="categories" :value="app">
                <label :for="`cssCheckbox_${app}`">{{ app }}</label>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>

</template>
<script>
const clinicalAreas = [
  'Cardiology',
  'Vascular',
  'Neurology',
  'Oncology',
  'Dental'
]
const modalities = ['MRI', 'Xray', 'Ultrasound', 'CT', 'Pet']
const applications = [
  'Workflow',
  'Visualisation',
  'Quantification',
  'Reporting'
]

export default {
  name: 'sidebar',
  data() {
    return {
      categories: [],
      modalities: modalities,
      clinicalAreas: clinicalAreas,
      applications: applications,
      searchInput: null,
      free: false,
      viewer: [],
      certified: false
    }
  },
  watch: {
    categories: function(val) {
      this.buildConditions()
    },
    searchInput: function(val) {
      this.$emit('searchText', val)
    },
    free: function(val) {
      this.buildConditions()
    },
    viewer: function(val) {
      this.buildConditions()
    },
    certified: function(val) {
      this.buildConditions()
    }
  },
  methods: {
    buildConditions() {
      const conditions = {}
      if (this.categories && this.categories.length > 0) {
        Object.assign(conditions, {
          categories: {
            $in: this.categories.map(it => it.toLowerCase())
          }
        })
      }

      if (this.viewer && this.viewer.length > 0) {
        Object.assign(conditions, {
          viewer: {
            $in: this.viewer.map(it => it.toLowerCase())
          }
        })
      }

      if (this.certified) {
        Object.assign(conditions, {
          certifications: {
            $in: ['ce', 'fda']
          }
        })
      }
      console.log(conditions)
      this.$emit('conditionsChange', conditions)
    }
  }
}
</script>
<style>
.category-list .fa-chevron-right {
  display: none;
}
.category-list .collapsed .fa-chevron-down {
  display: none;
}
.category-list .collapsed .fa-chevron-right {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue